import React, { useContext } from 'react';

import { PresetsContext } from '../PresetsContext';
import {
  useCreateGroup,
  useIsUpdating,
  useMoveToAnotherGroup,
  useMoveToUngrouped,
} from '../data';
import ManageGroupsSidepage from './ManageGroupsSidepage';

const ManageGroups = (props) => {
  const { presetKey, ownPresets, isLoading, isRefetching } =
    useContext(PresetsContext);

  const isUpdating = useIsUpdating();
  const [createGroup] = useCreateGroup(presetKey);
  const [moveTo] = useMoveToAnotherGroup(presetKey);
  const [moveToUngrouped] = useMoveToUngrouped(presetKey);

  const handleMoveTo = async ({ groupId, withCreate, ...group }) => {
    if (groupId || withCreate) {
      await moveTo({ groupId, withCreate, ...group });
    } else await moveToUngrouped(group);
  };

  return (
    <ManageGroupsSidepage
      presets={ownPresets}
      loading={isLoading || isUpdating}
      fetching={isRefetching}
      onAddGroup={createGroup}
      onMoveTo={handleMoveTo}
      presetKey={presetKey}
      {...props}
    />
  );
};

export default ManageGroups;
